import React from "react";
import equipmentImage from '../../img/equipment.png';


export const Services = (props) => {
  return (
    <div id="services" className="text-center">
      <div className="container">
        <div className="section-title">
          <h2>Solution for aerodromes</h2>
          <p>
          We offer aerodromes the opportunity to install an affordable and simple equipment on the ground to receive all types of econspicuity transmissions: ADS-B, FLARM, remote id, etc. and send this data to the app users. This enables efficient and accurate monitoring of air traffic, enhancing situational awareness and operational efficiency.
          </p>
          <img src={equipmentImage} alt="Aerodrome Equipment" className="aligned-img" />
        </div>
      </div>
    </div>
  );
};
